import { useState } from "react";
import { HomePage } from "./components/HomePage";
import { RegionSelection } from "./components/RegionSelection";
import { PatientWeight } from "./components/PatientWeight";
import { DosingResults } from "./components/DosingResults";
import { SmPCPage } from "./components/SmPCPage";

type AppScreen =
  | "home"
  | "regionSelection"
  | "dosingRegimen"
  | "patientWeight"
  | "results"
  | "smpc";

function App() {
  const [currentScreen, setCurrentScreen] = useState<AppScreen>("home");
  const [selectedRegion, setSelectedRegion] = useState<string | null>(null);

  const [selectedWeight, setSelectedWeight] = useState<string | null>(null);

  const handleStartCalculator = () => {
    setCurrentScreen("regionSelection");
  };

  const handleRegionSelect = (region: string) => {
    setSelectedRegion(region);
    setCurrentScreen("patientWeight");
  };

  const handleWeightSelect = (weightCategory: string) => {
    setSelectedWeight(weightCategory);
    setCurrentScreen("results");
  };

  const handleNewPatient = () => {
    // Reset all selections and go back to home
    setSelectedRegion(null);
    setSelectedWeight(null);
    setCurrentScreen("home");
  };

  const handleSmPCNavigate = () => {
    setCurrentScreen("smpc");
  };

  const renderScreen = () => {
    switch (currentScreen) {
      case "home":
        return <HomePage onStartCalculator={handleStartCalculator} />;
      case "regionSelection":
        return <RegionSelection onRegionSelect={handleRegionSelect} />;
      case "patientWeight":
        return (
          <PatientWeight
            selectedRegion={selectedRegion!}
            onWeightSelect={handleWeightSelect}
          />
        );
      case "results":
        return (
          <DosingResults
            selectedRegion={selectedRegion!}
            selectedWeight={selectedWeight!}
            onNewPatient={handleNewPatient}
            onSmPCNavigate={handleSmPCNavigate}
          />
        );
      case "smpc":
        return (
          <SmPCPage
            selectedRegion={selectedRegion!}
            onNewPatient={handleNewPatient}
          />
        );
      default:
        return <HomePage onStartCalculator={handleStartCalculator} />;
    }
  };

  return renderScreen();
}

export default App;
